export default __webpack_public_path__ + "static/InMe-2e70844e1c479f54f2503759a4e2cd05.png";